import React, { useCallback } from 'react';
import { DismissibleAdblockDialog, NonDismissibleAdblockOverlay } from '@colonist/clientforge';
import { AnalyticEventValue, AnalyticEventCategory, AnalyticEventType } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../../analytics/Analytics.ts';
import { navigateToPage } from '../../ui_utils/ClientUtils.ts';
import { uiManagerEvents } from '../../EntryShared.ts';
import { isSubscriptionOverlayVariant } from '../../store/subscription_overlay/subscriptionOverlayABTest.ts';
const sendAdblockClickAnalytic = (floatValue)=>{
    const eventData = {
        type: AnalyticEventType.ABTestClickAnalytics,
        category: AnalyticEventCategory.ABTestClickAnalytics,
        floatValue: floatValue
    };
    void CA.sendAnalyticEvent(eventData);
};
const clearLocationHash = ()=>{
    window.history.pushState('', document.title, window.location.pathname + window.location.search);
};
export const DisableAdblockDialogContainer = ({ open, onClose, variant, continuationAction })=>{
    const handleClose = useCallback(()=>{
        if (variant == 'dismissible') {
            sendAdblockClickAnalytic(AnalyticEventValue.AdblockPopupContinueAction);
            continuationAction();
        }
        clearLocationHash();
        onClose();
    }, [
        variant,
        continuationAction,
        onClose
    ]);
    const navigateToDisableAdblockPage = useCallback(()=>{
        sendAdblockClickAnalytic(AnalyticEventValue.AdblockPopupDisableAction);
        clearLocationHash();
        onClose();
        navigateToPage('/disable-ad-block', true);
    }, [
        onClose
    ]);
    const navigateToStoreMembershipPage = useCallback(()=>{
        sendAdblockClickAnalytic(AnalyticEventValue.AdblockPopupBecomeMemberAction);
        clearLocationHash();
        onClose();
        if (isSubscriptionOverlayVariant()) uiManagerEvents.premiumMembershipCheckAction();
        else navigateToPage('/store#membership', true);
    }, [
        onClose
    ]);
    if (variant == 'dismissible') {
        return /*#__PURE__*/ React.createElement(DismissibleAdblockDialog, {
            open: open,
            onClose: handleClose,
            onDisableAdblock: navigateToDisableAdblockPage,
            onBecomeMember: navigateToStoreMembershipPage
        });
    }
    return /*#__PURE__*/ React.createElement(NonDismissibleAdblockOverlay, {
        open: open,
        onDisableAdblock: navigateToDisableAdblockPage,
        onBecomeMember: navigateToStoreMembershipPage
    });
};
